const Footer = () => (
<footer className="max-w-md pb-16 text-sm text-slate-500 sm:pb-0">
<p>Built with React, TypeScript and Tailwind CSS. Focused on building scalable systems, solving complex engineering challenges, and continuously learning.</p>
</footer>
);
export default Footer;